__turbopack_context__.v({
  "expires_desktop": "ExpiryPill-module-scss-module__bLdmjq__expires_desktop",
  "expires_mobile": "ExpiryPill-module-scss-module__bLdmjq__expires_mobile",
});
